import { VUwebSearchService } from "@/shared/services/azure-search-service";

export default class  SearchOverlayWidgetState   {
    searchResults = {
        count: 0,
        results: []
    };
    employeeResults= {
        count: 0,
        results: []
    };
    searchQuery = '';
    searchActive = false;
    loading= true;
    isExternalSearchActive= true;
    error= '';
    azureService = new VUwebSearchService('');
    config= {
        language: 'NL',
        endpoint: '',
        labels: {},
        searchSettings: {
            overviewUrl: '',
            scope: '',
            itemType: '',
            index: ''
        },
        employeeSettings: {
            overviewUrl: ''
        },
        externalSearchSettings: {
            overviewUrl: '',
        },
    }
}